import type { ThemeSize } from '../../stores/themeStore';

/**
 * PSI staff easter egg (Jeff, 2026-10-21): choosing the biggest UI size
 * (X-Large since there are four; it was Large) shows a cartoon grandmother. The size pickers call this on a click; loading the saved
 * size or syncing it from the server goes straight to the store and never
 * passes through here, so neither one shows her. GrannyEasterEgg decides who
 * sees it. Remove this file, GrannyEasterEgg.tsx/.css and the three calls to
 * take it out.
 */
export const GRANNY_EVENT = 'dietech:granny-large';

export function noteSizeChoice(previous: ThemeSize, next: ThemeSize): void {
  if (next !== 'xlarge' || previous === 'xlarge') return;
  window.dispatchEvent(new CustomEvent(GRANNY_EVENT));
}
